import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { StorageService } from './StorageService';

@Injectable({
    providedIn: 'root'
})
export class CandidateAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private storageService: StorageService
    ) { }

    canActivate(): boolean | UrlTree {
        const candidateProfileDetails =
            this.storageService.getItem('CandidateProfileDetail');

        if (candidateProfileDetails) {
            return true;
        }

        // return UrlTree instead of navigate
        return this.router.createUrlTree(['/CandidateSignIn']);
    }
}
